import classNames from 'classnames';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DROPSHIPPING_REQUEST_PRODUCT from '../../../../components/constant/dropshippingRequestProduct';

const allowColor = '#4caf50';
const pendingColor = '#ff9800';
const denyColor = '#dc004e';
const useStyles = makeStyles({
  itemStatusAllow: { color: allowColor },
  itemStatusPending: { color: pendingColor },
  itemStatusDeny: { color: denyColor },
});

interface IProps {
  status: string;
  hideText?: boolean;
  showIcon?: boolean;
  iconSize?: 'inherit' | 'large' | 'medium' | 'small';
}

export default function LabelDropshippingRequestProductStatus(props: IProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { status, iconSize, hideText, showIcon } = props;

  let htmlColor;

  if (status === DROPSHIPPING_REQUEST_PRODUCT.STATUS.PENDING) {
    htmlColor = pendingColor;
  } else if (status === DROPSHIPPING_REQUEST_PRODUCT.STATUS.ALLOW) {
    htmlColor = allowColor;
  } else {
    htmlColor = denyColor;
  }
  return (
    <>
      {showIcon && (
        <>
          <Tooltip title={t(status)}>
            <div>
              <FiberManualRecordIcon
                htmlColor={htmlColor}
                fontSize={iconSize}
              />
            </div>
          </Tooltip>
          &nbsp;
        </>
      )}
      {!hideText && (
        <Typography
          variant="subtitle1"
          display="inline"
          className={classNames({
            [classes.itemStatusAllow]:
              status === DROPSHIPPING_REQUEST_PRODUCT.STATUS.ALLOW,
            [classes.itemStatusPending]:
              status === DROPSHIPPING_REQUEST_PRODUCT.STATUS.PENDING,
            [classes.itemStatusDeny]:
              status === DROPSHIPPING_REQUEST_PRODUCT.STATUS.DENY,
          })}
        >
          <>{t(status)}</>
        </Typography>
      )}
    </>
  );
}
